// Sentry init for the client. Call once from main.tsx before any React render.
// When VITE_SENTRY_DSN is unset (local dev), init is skipped and every
// Sentry.* call no-ops — no network traffic, no warnings.

import * as Sentry from '@sentry/react'

export const initSentry = (): void => {
  const dsn = import.meta.env.VITE_SENTRY_DSN
  if (!dsn) return

  Sentry.init({
    dsn,
    environment: import.meta.env.MODE,
    release: import.meta.env.VITE_SENTRY_RELEASE,
    // Errors only — no perf, no replay. Both add bundle weight and dollars.
    tracesSampleRate: 0,
  })
}

// Re-export so callers don't need to import @sentry/react directly.
export { Sentry }
